import {
  FAQS,
  FooterLinks,
  AnalyticsHeader,
  NavSubmenuLinks,
  TERMS_AND_CONDITION,
  PASS_PURCHASE_SUCCESS_MESSAGE,
} from "./helper";
import { routes } from "src/shared/routes";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

export const texasrangers_pass: TTeamConfig = {
  TEAM_SCHEMA: "texasrangers_pass",
  TEAM_FULL_NAME: "Texas Rangers",
  BROWSER_TITLE: "Rangers Ballpark Pass",
  CLIENT_ID: "lITINc9C84pYHUWlC4Bd9y8UVKBCoKj3p7xmfxnmAZBJVDvG",
  VENDOR: "TDC",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#003278",
    COLORS_SECONDARY: "#C0111F",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    IS_INTERCOM_ENABLED: true,
    ACCOUNT_MANAGER_URL: "https://bp.mlb.com/Wallet",
    ANALYTICS_HEADER: AnalyticsHeader,

    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      ADDITIONAL_SUB_MENU_ITEMS: NavSubmenuLinks,
      LOGIN_LABEL: "Manage Pass",
      HIDE_SIGN_OUT_BUTTON: true,
    },

    FOOTER: {
      COPYRIGHT_TEXT: `© ${new Date().getFullYear()} MLB Advanced Media, L.P. All rights reserved`,
      LINKS: FooterLinks,
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <TERMS_AND_CONDITION />,
    },
    HIDE_ACCOUNT_DETAILS: true,
  },

  LANDING_PAGE_SETTINGS: {
    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
      HIDE_PASS_DETAILS: true,
    },

    PASS: {
      ADD_SERVICE_FEE_TO_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Buy Now!",
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SHOW_FAQ_BUTTON: true,
      SUBSCRIBE_BUTTON_COLOR: "#24a133",
    },

    SHOW_ALL_PASSES_UNDER_BANNER: true,
  },

  HOME_PAGE_SETTINGS: {
    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
    },

    ADD_ON: {
      ADD_SERVICE_FEE_TO_PRICE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },

    ADD_ONS_LABEL: "Tickets",
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/Texas%20Rangers/T_Primary.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/TX%20Rangers%20Suites/rangersstadium.jpg",
    FOOTER_LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/MLB/Texas%20Rangers/T_White.png",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    PASS_PURCHASE_SUCCESS_MESSAGE,
    PRE_PURCHASE_FAQS: FAQS,
  },
};
